module.exports = __webpack_public_path__ + "static/media/profile_placeholder.a785b25b.png";